import { createSlice } from '@reduxjs/toolkit';
import { authApi } from './auth.api';

const token = localStorage.getItem('token');
const moduleItems = [];

function storeToken(value) {
  if (value && value.length > 0) {
    localStorage.setItem('token', value);
    document.cookie = 'keep-me-signed-in=Y; path=/; secure; samesite=strict';
  } else {
    localStorage.removeItem('token');
  }
}

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token,
    modules: moduleItems,
  },
  extraReducers: (builder) => {
    builder.addMatcher(authApi.endpoints.login.matchFulfilled, (state, { payload }) => {
      if (payload.token && payload.token !== 'NA') {
        state.token = payload.token;
        storeToken(payload.token);
      }
    });
    builder.addMatcher(authApi.endpoints.getNavigation.matchFulfilled, (state, action) => {
      const { modules, ...additionalData } = action.payload?.data || {};
      state.modules = modules;
      const newArray = [];

      const buildMenuPath = (menu, parentPath = '') => {
        const currentPath = parentPath ? `${parentPath} > ${menu.caption}` : menu.caption;

        if (menu.childMenu?.length) {
          menu.childMenu.forEach((child) => buildMenuPath(child, currentPath));
        } else {
          const parentPathOnly = parentPath || menu.caption;
          newArray.push({
            label: menu.caption,
            value: menu.caption,
            path: menu.screenPath,
            menuId: menu.menuId,
            fullPath: parentPathOnly,
          });
        }
      };

      modules.forEach((module) => {
        if (module.menus.length) {
          module.menus.forEach((menu) => buildMenuPath(menu, module.moduleName));
        } else {
          newArray.push({
            label: module.moduleName,
            value: module.moduleName,
            path: module.path,
            menuId: module.moduleId,
            fullPath: module.moduleName,
          });
        }
      });

      localStorage.setItem('navItems', JSON.stringify(newArray));
      state.items = newArray;
      localStorage.setItem('navMenus', JSON.stringify(modules));
      state.info = { ...state.info, ...additionalData };
    });
  },
  reducers: {
    updateAuthValue: (state, action) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
    setToken: (state, { payload }) => {
      state.token = payload;
      storeToken(payload);
    },
  },
});

export const { setToken, updateAuthValue } = authSlice.actions;

export const getToken = (state) => state.auth?.token;
